
export const runningTotal = (arr : number[]) : number[] => {    
    const newArray:number[] = [];
    arr.reduce(
        (a,b,i) => newArray[i] = a+b, 
        0);
    return newArray;
}

